<template>
  <div ref="rootRef" class="relative flex h-full flex-col overflow-hidden">
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { onBeforeUnmount, onMounted, ref } from 'vue'

import { SCROLL_CONTAINER_ATTRIBUTE } from '../../../constants'

const rootRef = ref<HTMLDivElement | null>(null)

function shouldPreventScroll(event: WheelEvent | TouchEvent): boolean {
  const { target } = event
  if (!(target instanceof Element)) return false
  if (target.closest(`[${SCROLL_CONTAINER_ATTRIBUTE}]`)) return false

  return true
}

function onScrollEvent(event: WheelEvent | TouchEvent) {
  if (shouldPreventScroll(event)) event.preventDefault()
}

onMounted(() => {
  const el = rootRef.value
  if (!el) return
  el.addEventListener('wheel', onScrollEvent, { passive: false })
  el.addEventListener('touchmove', onScrollEvent, { passive: false })
})

onBeforeUnmount(() => {
  const el = rootRef.value
  if (!el) return
  el.removeEventListener('wheel', onScrollEvent)
  el.removeEventListener('touchmove', onScrollEvent)
})
</script>
